import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('fileMarketNewProducts', {
        template: require('./fileMarketNewProductsComponent.html'),
        bindings: {
            oracleIndexes: '=',
            readOnly: '<',
            countryCode: '<'
        },
        controller: ['mlDataService', AgGridService.componentName, angularServicesNames.$translate, '$uibModal', '$scope', function(
            this: $TSFixMe,
            mlDataService: $TSFixMe,
            agGridService: AgGridService,
            $translate: ng.translate.ITranslateService,
            $uibModal: ng.ui.bootstrap.IModalService,
            $scope: $TSFixMe
        ) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                refreshGrid();
            };

            function refreshGrid() {
                if ($ctrl.gridApi && $ctrl.oracleIndexes) {
                    $ctrl.serverOperation = mlDataService.getProductData($ctrl.oracleIndexes)
                        .then((items: $TSFixMe) => $ctrl.gridApi.setRowData(items));
                }
            }

            $ctrl.addNewProducts = () => {
                var modal = $uibModal.open({
                    component: 'imsIoNewProductsSelector',
                    resolve: {
                        exceptProductList: () => [],
                        countryCode: () => $ctrl.countryCode
                    },
                    size: 'lg'
                });
                modal.result.then((oracleIndexes: $TSFixMe) => {
                    for (const oracleIndex of oracleIndexes) {
                        $ctrl.oracleIndexes.push(oracleIndex);
                    }
                    refreshGrid();
                }, () => { });
            };

            $ctrl.removeFilter = (data: $TSFixMe) => {
                var i = $ctrl.oracleIndexes.indexOf(data.oracleIndex);
                if (i >= 0) {
                    $ctrl.oracleIndexes.splice(data.oracleIndex, 1)
                }
                refreshGrid();
            }

            $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

            $ctrl.newProdcutsGridOptions = {
                columnDefs: [
                    { field: 'oracleIndex', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ORACLE_INDEX") },
                    { field: 'sku', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.SKU") },
                    { field: 'brand', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.BRAND") },
                    { field: 'bloz', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.BLOZ") },
                    {
                        field: 'actions', headerValueGetter: () => $translate.instant("ACTIONS"),
                        cellRenderer: () => '<div class="ui-grid-cell-contents"><a ng-if="!$ctrl.readOnly" href="#" ng-click="$ctrl.removeFilter(data)"><i class="glyphicon glyphicon-remove"></i></a></div>', width: 70,
                    },
                ],
                angularCompileRows: true,
                defaultColDef: {
                    sortable: true,
                    resizable: true
                },
                enableFilter: false,
                animateRows: true,
                pagination: true,
                paginationPageSize: 10,
                localeTextFunc: agGridService.transalteFunc,
                suppressHorizontalScroll: true,
                domLayout: 'autoHeight',
                onGridReady: (config: $TSFixMe) => {
                    $ctrl.gridApi = config.api;
                    config.api.sizeColumnsToFit();
                    refreshGrid();
                },
                onGridSizeChanged: (config: $TSFixMe) => {
                    config.api.sizeColumnsToFit();
                }
            };
        }]
    })

})(angular.module('topline.modules'));